"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = require("./types");

var T = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = [{
  name: "swarmling",
  maxHp: 5,
  attack: 5
}, {
  name: "swarmling-queen",
  prod: { swarmling: 2 }
}, {
  name: "tower",
  maxHp: 100000,
  attack: 100000
}, {
  name: "lair",
  maxHp: 3000
}, {
  name: "overlord",
  maxHp: 5
}, {
  name: "overlord-den",
  prod: { overlord: 1 / 3 }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3NvbGRpZXItdHlwZXMvanNvbi5qcyJdLCJuYW1lcyI6WyJUIiwibmFtZSIsIm1heEhwIiwiYXR0YWNrIiwicHJvZCIsInN3YXJtbGluZyIsIm92ZXJsb3JkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQTs7SUFBWUEsQzs7OztrQkFDSSxDQUNkO0FBQ0VDLFFBQU0sV0FEUjtBQUVFQyxTQUFPLENBRlQ7QUFHRUMsVUFBUTtBQUhWLENBRGMsRUFNZDtBQUNFRixRQUFNLGlCQURSO0FBRUVHLFFBQU0sRUFBQ0MsV0FBVyxDQUFaO0FBRlIsQ0FOYyxFQVVkO0FBQ0VKLFFBQU0sT0FEUjtBQUVFQyxTQUFPLE1BRlQ7QUFHRUMsVUFBUTtBQUhWLENBVmMsRUFlZDtBQUNFRixRQUFNLE1BRFI7QUFFRUMsU0FBTztBQUZULENBZmMsRUFtQmQ7QUFDRUQsUUFBTSxVQURSO0FBRUVDLFNBQU87QUFGVCxDQW5CYyxFQXVCZDtBQUNFRCxRQUFNLGNBRFI7QUFFRUcsUUFBTSxFQUFDRSxVQUFVLElBQUksQ0FBZjtBQUZSLENBdkJjLEMiLCJmaWxlIjoianNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBUIGZyb20gXCIuL3R5cGVzXCJcbmV4cG9ydCBkZWZhdWx0IChbXG4gIHtcbiAgICBuYW1lOiBcInN3YXJtbGluZ1wiLFxuICAgIG1heEhwOiA1LFxuICAgIGF0dGFjazogNSxcbiAgfSxcbiAge1xuICAgIG5hbWU6IFwic3dhcm1saW5nLXF1ZWVuXCIsXG4gICAgcHJvZDoge3N3YXJtbGluZzogMn0sXG4gIH0sXG4gIHtcbiAgICBuYW1lOiBcInRvd2VyXCIsXG4gICAgbWF4SHA6IDEwMDAwMCxcbiAgICBhdHRhY2s6IDEwMDAwMCxcbiAgfSxcbiAge1xuICAgIG5hbWU6IFwibGFpclwiLFxuICAgIG1heEhwOiAzMDAwLFxuICB9LFxuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZFwiLFxuICAgIG1heEhwOiA1LFxuICB9LFxuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZC1kZW5cIixcbiAgICBwcm9kOiB7b3ZlcmxvcmQ6IDEgLyAzfSxcbiAgfSxcbl06IFQuU3RhdGUpXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/soldier-types/json.js
// module id = 804
// module chunks = 0